.container {
  font-size: var(--tuna-typography-fontSize-xs);
  cursor: pointer;
}
